import * as THREE from 'three';
import { SAKURA_TIPS, sakuraTipName } from '../../assets/catalog';
import { leafCards } from '../far/layout';
import type { Vec3 } from '../frame';

/** Phase-2 foliage state for the sakura v0: early-autumn green (seasons arrive in phase 6). */
export const LEAF_COLOR = new THREE.Color(0x3d5a2a);
const CARDS_PER_TIP = 70;
const RADIUS_M = 0.75;

/** Instanced leaf cards around the sakura's exported tip empties (world space). */
export function buildLeafCards(sakura: THREE.Object3D, seed: number): THREE.InstancedMesh {
  sakura.updateWorldMatrix(true, true);
  const tips: Vec3[] = [];
  for (let i = 0; i < SAKURA_TIPS; i++) {
    const tip = sakura.getObjectByName(sakuraTipName(i));
    if (!tip) continue;
    const p = tip.getWorldPosition(new THREE.Vector3());
    tips.push([p.x, p.y, p.z]);
  }
  const cards = leafCards(seed, tips, CARDS_PER_TIP, RADIUS_M);
  const mesh = new THREE.InstancedMesh(
    new THREE.PlaneGeometry(0.2, 0.2),
    new THREE.MeshStandardMaterial({ color: LEAF_COLOR, roughness: 0.8, side: THREE.DoubleSide }),
    cards.length,
  );
  mesh.name = 'sakura_leaves';
  const m = new THREE.Matrix4();
  cards.forEach((c, i) => {
    m.compose(
      new THREE.Vector3(...c.position),
      new THREE.Quaternion().setFromEuler(new THREE.Euler(...c.rotation)),
      new THREE.Vector3(c.scale, c.scale, c.scale),
    );
    mesh.setMatrixAt(i, m);
  });
  return mesh;
}
